<div class="flex flex-col gap-3">
    <span class="font-bold text-xl" i18n>Date</span>
    <span i18n>Please specify the month you want to synchronize the Urban Sports Club memberships with our subscriptions.</span>

    <div class="w-full flex flex-row justify-center my-5">
        <div class="w-full max-w-md">
            <app-month-and-year-picker (valueChanges)="onDateChanged($event)"></app-month-and-year-picker>
        </div>
    </div>

    <span i18n>
        With this process you will confirm and add the price information to Urban Sports Club subscriptions in chæmp. All confirmed users
        with an active Urban Sports Club membership will become available for the billing process of customers product invoices.
    </span>
</div>
